import ModalWindow from "components/ModalWindow";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { BASE_URL } from "consts/APIUrls";
import useProfile from "hooks/useProfile";
import React, { useEffect, useState } from "react";
import { createAPI } from "services/api/api";

const SellWidget = ({ close }) => {
  // const api = createAPI();
  // const { email, user_wallet } = useProfile();
  // const [signedPayload, setSignedPayload] = useState("");

  // useEffect(() => {
  //   if (!user_wallet || !email) return;

  //   const payload = `wallet=usdc:${user_wallet}&email=${encodeURIComponent(email)}`;

  //   api.post(`${BASE_URL}/onramper/sign`, {
  //     "data": payload,
  //   })
  //     .then((res) => res.data)
  //     .then(({ signature }) => {
  //       setSignedPayload(`&${payload}&signature=${signature}`);
  //     })
  //     .catch((err) => {
  //       console.error("Failed to get signature:", err);
  //     });
  // }, [user_wallet, email]);

  // const apiKey =
  //   window.location.origin === "https://game.twotwentyk.io" || 'https://stage.twotwentyk.io/'
  //     ? "pk_prod_01K18VWSV2NNYSVHFGWMNT2YKE"
  //     : "pk_test_01K0PH6P2NZMKJMQ4DC375R0QD";

  // const iframeSrc = `https://buy.onramper.com/?apiKey=${apiKey}&mode=sell&onlyOnramps=banxa,topper,coinbasepay,gatefi,onrampmoney&defaultCrypto=usdc_polygon&onlyCryptos=usdc_polygon&defaultFiat=usd&onlyFiats=usd&defaultAmount=100&defaultPaymentMethod=debitcard&onlyCryptoNetworks=polygon&sell_onlyOfframps=banxa,gatefi,onrampmoney,transfi&sell_defaultFiat=usd&sell_onlyFiats=usd&sell_defaultAmount=100&sell_defaultCrypto=usdc_polygon&sell_onlyCryptos=usdc_polygon&sell_onlyCryptoNetworks=polygon&sell_defaultPaymentMethod=debitcard&themeName=dark${signedPayload}`;

  return (
    <ModalWindow close={close}>
      <div className="modal-window__wrapper modal-window__wrapper--add-funds modal-window__wrapper--withdraw-funds">
        <PagePopopCloseButton close={close} />
        <p className="add-funds__text">
          <span>
            Self-Service withdrawls are temporarily unavailable. <br />
            To withdraw funds from your wallet, fill out the form below
          </span>
          </p>
          <iframe
          id="JotFormIFrame-252654105261147"
          title="Withdrawl Request Form"
          allowtransparency="true"
          allow="geolocation; microphone; camera; fullscreen; payment"
          src="https://form.jotform.com/252654105261147"
          frameborder="0"
          style={{
            minWidth: "100%",
            maxWidth: "100%",
            height: "539px",
            border: "none",
            marginTop: 15,
          }}
        />
        {/* <iframe
          src={iframeSrc}
          title="Onramper Widget Sell"
          width="100%"
          height="630px"
          style={{
            width: "100%",
            height: "630px",
            border: "none",
          }}
          allow="accelerometer; autoplay; camera; gyroscope; payment; microphone"
        /> */}
      </div>
    </ModalWindow>
  );
};

export default SellWidget;
